<template>
    <form
        @submit.prevent="updatePhoto"
        :action="url"
        ref="form"
        method="post"
        class="card space-y-4 md:flex md:flex-row md:space-y-0 md:space-x-4 "
    >
        <div class="md:w-1/3 bg-red-500">
            <div class="w-full relative bg-black pb-[100%]">
                <img :src="photo.url" :alt="photo.name" class="absolute w-full h-full inset-0 object-contain object-center">
            </div>
        </div>

        <div class="flex-1 flex flex-col space-y-4">
            <text-input
                class="flex-1"
                label="Name"
                name="name"
                v-model="updateForm.name"
                :error="updateForm.errors.name"
                :placeholder="namePlaceholder"
            />

            <select-input
                v-if="length > 1"
                label="Position"
                name="position"
                v-model="updateForm.position"
                :error="updateForm.errors.position"
            >
                <option value="">Please select one</option>
                <option v-for="option in options" :key="option">{{ option }}</option>
            </select-input>

            <div class="self-end flex space-x-4">
                <loading-button
                    v-if="showDeleteButton"
                    @click.prevent="deletePhoto"
                    :loading="deleteForm.processing"
                    class="btn btn-gray"
                    type="button"
                >
                    Delete
                </loading-button>

                <loading-button
                    :loading="updateForm.processing"
                    class="btn btn-green"
                    type="submit"
                >
                    Update
                </loading-button>
            </div>
        </div>
    </form>
</template>

<script setup>
import { range } from 'lodash'
import useForm from '@/functions/useForm'
import { computed } from '@vue/reactivity'

const props = defineProps({
    photo: {
        type: Object,
        required: true,
    },
    length: {
        type: Number,
        required: true
    },
    url: {
        type: String,
        required: true,
    }
})

const updateForm = useForm({
    name: props.photo.name,
    position: props.photo.position
})

const deleteForm = useForm({})

const options = computed(() => {
    return range(1, props.length + 1)
})
const year = computed(() => {
    return new Date().getFullYear()
})
const namePlaceholder = computed(() => {
    return `${year.value} - Face From Fair`
})

const showDeleteButton = computed(() => {
    return props.length > 1;
})

const updatePhoto = () => {
    updateForm.put(props.url, {
        onSuccess: () => window.location.reload()
    })
}
const deletePhoto = () => {
    deleteForm.delete(props.url, {
        onSuccess: () => window.location.reload()
    })
}
</script>
